module.exports = __webpack_public_path__ + "img/ico04.7b5f9238.svg";